export enum PathName {
  ActivityFeed = '/dashboard/activity-feed',
  Admin = '/dashboard/admin',
  AdminReports = '/dashboard/reports/admin',
  AgingConfiguration = '/dashboard/admin/aging-configuration',
  AiTools = '/dashboard/ai-tools',
  AppointmentTypes = '/dashboard/admin/appointment-types',
  Articles = '/dashboard/articles',
  Availability = '/dashboard/appointments/availability',
  BillingConfiguration = '/dashboard/admin/billing-config',
  Calendar = '/dashboard/appointments',
  ClinicalTools = '/dashboard/clinical-tools',
  CreateArticle = '/dashboard/articles/create',
  CrossSell = '/cross-sell',
  CustomerFeedback = '/dashboard/admin/customer-feedback',
  Dashboard = '/dashboard',
  EmailTemplates = '/dashboard/admin/email-templates',
  ExternalVideoCall = '/external-video-call',
  FormsAndSurveys = '/dashboard/admin/forms-and-surveys',
  FrontDeskRequestTypes = '/dashboard/admin/front-desk-request-types',
  Insurance = '/dashboard/insurance',
  InternalAutomations = '/dashboard/admin/internal-automations',
  InternalNoteTemplates = '/dashboard/admin/internal-note-templates',
  Login = '/',
  ManageProducts = '/dashboard/admin/manage-products',
  ManageRole = '/dashboard/admin/manage-role',
  ManageRoles = '/dashboard/admin/manage-roles',
  MedicalAssistantReports = '/dashboard/reports/medical-assistant',
  MedicationTemplates = '/dashboard/admin/medication-templates',
  MSRTaskDetail = '/dashboard/msr-tasks/:taskId',
  MSRTasks = '/dashboard/msr-tasks',
  MSRTasksConfig = '/dashboard/admin/msr-tasks-config',
  NotFound = '*',
  Orders = '/dashboard/orders',
  Patient = '/dashboard/patient',
  PatientAutomations = '/dashboard/admin/patient-automation',
  PatientMessageTemplates = '/dashboard/admin/patient-message-templates',
  Patients = '/dashboard/patients',
  PdmpConfigs = '/dashboard/admin/pdmp-configs',
  PhysicianReports = '/dashboard/reports/physician',
  PhysicianRequestTypes = '/dashboard/physician-request-types',
  Prospect = '/dashboard/patients/prospect',
  QA = '/dashboard/qa',
  RefundReasons = '/dashboard/admin/refund-reasons',
  RequestMessageTemplates = '/dashboard/admin/request-message-templates',
  Reviews = '/dashboard/admin/reviews',
  Scheduling = '/dashboard/scheduling',
  SchedulingCapacity = '/dashboard/scheduling/capacity',
  SchedulingCoverage = '/dashboard/scheduling/coverage',
  SchedulingInsurance = '/dashboard/scheduling/coverage-insurance',
  SchedulingRoster = '/dashboard/scheduling/roster',
  SchedulingTemplates = '/dashboard/scheduling/templates',
  SchedulingTimeline = '/dashboard/scheduling/timeline',
  ShopPages = '/dashboard/admin/shop-pages',
  ShopSegments = '/dashboard/admin/shop-segments',
  SignableDocuments = '/dashboard/admin/signable-documents',
  StaffAnnouncements = '/dashboard/admin/staff-announcements',
  StaffCosts = '/dashboard/admin/staff-costs',
  StaffFeedback = '/dashboard/admin/staff-feedback',
  Staffs = '/dashboard/admin/manage-staff',
  SystemSettings = '/dashboard/admin/system-settings',
  Tasks = '/dashboard/tasks',
  Teams = '/dashboard/admin/manage-teams',
  Templates = '/dashboard/templates',
  UpdateArticle = '/dashboard/articles/update',
  WorkflowDetails = '/dashboard/workflows/:id',
  Workflows = '/dashboard/workflows'
}
